import { EventMember, EventMemberRole } from 'types/api'

export interface EventAccess {
  role: EventMemberRole | null
  superuser: boolean
  canManage: boolean
}

export const eventRoleFor = (
  members: EventMember[],
  userId: string | null | undefined
): EventMemberRole | null => {
  if (userId == null || userId === '') return null
  return members.find((m) => m.userId === userId)?.role ?? null
}

export const eventAccessFor = ({
  members,
  userId,
  superuser
}: {
  members: EventMember[]
  userId: string | null | undefined
  superuser: boolean
}): EventAccess => {
  const role = eventRoleFor(members, userId)
  const canManage = superuser || role === 'owner'
  return { role, superuser, canManage }
}
